import * as R from 'ramda';


export default function searchVendors(vendors, filters) {
  /**
   * Expected "filters" model:
   *  {
   *     inherentRiskNone: bool,
   *     inherentRiskLow: bool,
   *     inherentRiskMedium: bool,
   *     inherentRiskHigh: bool,
   *     residualRiskNone: bool,
   *     residualRiskLow: bool,
   *     residualRiskMedium: bool,
   *     residualRiskHigh: bool,
   *     showNone: bool,
   *     showReminders: bool,
   *     showAlerts: bool,
   *     searchText: string,
   *  }
   */

  console.log('app.services.vendorsFilters.searchVendors created');
  if (!R.is(Array, vendors)) return []; // Return empty array if no vendors
  const filtered = [];

  vendors.forEach((vendor) => {
    if (searchVendor(vendor, filters)) {
      filtered.push(vendor);
    }
  });
  console.log('app.services.vendorsFilters.searchVendors filtered vendors');
  return filtered;
}


/** ************************************************
 * Private Functions
 */

function searchVendor(vendor, filters) {
  console.log('app.services.vendorsFilters.searchVendor created');
  const nameWasSearched = filters.searchText.toLocaleLowerCase() !== '';
  const isVendorNameMatch = !nameWasSearched || search(vendor.name, filters.searchText);

  /* Has Products */
  if (R.is(Array, vendor.products) && vendor.products.length > 0) {
    const selectedProductTest = createSelectedProductTest(vendor, filters, isVendorNameMatch, nameWasSearched);
    const hasSelectedProduct = R.any(selectedProductTest)(vendor.products);

    console.log('app.services.vendorsFilters.searchVendor filtered vendors');
    return (nameWasSearched && isVendorNameMatch) || hasSelectedProduct;
  }

  /* No Products */
  return isVendorNameMatch
    && filters.inherentRiskNone
    && filters.residualRiskNone
    && filters.showNone;
}

function search(stringToSearch, searchText) {
  return stringToSearch.toLocaleLowerCase().indexOf(searchText.toLocaleLowerCase()) > -1;
}

function createSelectedProductTest(vendor, filters, isVendorNameMatch, nameWasSearched) {
  return (product) => {
    if (!doesProductHaveAllFlags(product, filters)) return false;
    const isProductNameMatch = !nameWasSearched || search(product.name, filters.searchText);

    return isVendorNameMatch || isProductNameMatch;
  };
}

function doesProductHaveAllFlags(product, filters) {
  const productInherentRiskShown = isProductInherentRiskShown(product.riskTier, filters);
  const productResidualRiskShown = isProductResidualRiskShown(product.residualRiskDisplay, filters);
  const productAttentionShown = isProductAttentionShown(product.alertCount, product.remindCount, filters);

  return productInherentRiskShown && productResidualRiskShown && productAttentionShown;
}

function isProductAttentionShown(alertCount, remindCount, filters) {
  return ((alertCount === 0 && remindCount === 0 && filters.showNone)
    || (remindCount > 0 && filters.showReminders)
    || (alertCount > 0 && filters.showAlerts));
}

function isProductInherentRiskShown(productRiskTier, filters) {
  switch (productRiskTier) {
    case 'N/A':
      return filters.inherentRiskNone;
    case 'I':
      return filters.inherentRiskLow;
    case 'II':
      return filters.inherentRiskMedium;
    case 'III':
      return filters.inherentRiskHigh;
    default:
      return false;
  }
}

function isProductResidualRiskShown(productResidualRiskDisplay, filters) {
  switch (productResidualRiskDisplay) {
    case 'N/A':
      return filters.residualRiskNone;
    case 'LOW':
      return filters.residualRiskLow;
    case 'MED':
      return filters.residualRiskMedium;
    case 'HIGH':
      return filters.residualRiskHigh;
    default:
      return false;
  }
}
